export default __webpack_public_path__ + "locales/sl/DeleteThirdPartyDialog.json?hash=6353d3933bdd187e0205da393d2de5e3";